import { useEffect, useRef } from 'react'
import { createConsumer, type Subscription } from '@rails/actioncable'

interface ChannelCallbacks {
  received?: (data: any) => void
  connected?: () => void
  disconnected?: () => void
}

// Cookie-session ActionCable subscription for the Inertia web app. The
// same-origin WebSocket to /cable carries the Rails session cookie, which
// ApplicationCable::Connection verifies — no token needed (unlike the old
// Next.js app that passed ?access_token from localStorage).
export function useChannel(channelName: string, callbacks: ChannelCallbacks) {
  const subscription = useRef<Subscription | null>(null)
  const cbRef = useRef(callbacks)
  cbRef.current = callbacks

  useEffect(() => {
    const consumer = createConsumer('/cable')
    subscription.current = consumer.subscriptions.create(
      { channel: channelName },
      {
        received: (data: any) => cbRef.current.received?.(data),
        connected: () => cbRef.current.connected?.(),
        disconnected: () => cbRef.current.disconnected?.(),
        rejected: () => console.error(`Connection to ${channelName} was rejected`),
      },
    )

    return () => {
      subscription.current?.unsubscribe()
      consumer.disconnect()
    }
  }, [channelName])

  return subscription.current
}
